export default __webpack_public_path__ + "static/media/dfinity-earth-night.37b200bd.jpg";